import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import { Navbar, Nav, Container } from "react-bootstrap"; // Importa componentes de Bootstrap

// Importa tus componentes de página
import HomePage from "./components/HomePage";
import GalleryPage from "./components/GalleryPage";
import InfoPage from "./components/InfoPage";
import DataFormPage from "./components/DataFormPage";
import Footer from "./components/Footer"; // Importa el nuevo componente Footer

function App() {
  return (
    <Router>
      <Navbar
        bg="dark"
        variant="dark"
        expand="lg"
        className="sticky-top shadow"
      >
        <Container>
          <Navbar.Brand as={Link} to="/">
            Sudam 2027
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link as={Link} to="/">
                Inicio
              </Nav.Link>
              <Nav.Link as={Link} to="/galeria">
                Galería
              </Nav.Link>
              <Nav.Link as={Link} to="/informacion">
                Información
              </Nav.Link>
              <Nav.Link as={Link} to="/formulario">
                Inscripción de Pilotos
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <Container className="mt-4 mb-5 pb-5">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/galeria" element={<GalleryPage />} />
          <Route path="/informacion" element={<InfoPage />} />
          <Route path="/formulario" element={<DataFormPage />} />
        </Routes>
      </Container>
      <Footer /> {/* Agrega el componente Footer aquí */}
    </Router>
  );
}

export default App;
